let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jVZVT")).then(() => parcelRequire('5bdUZ'));